<template>
  <div class="form-group" :class="{'has-error': !!errorText}">
    <label class="control-label col-md-3">{{ title }}</label>
    <div class="col-md-9">
      <input :id="id" :name="name" type="file" :accept="accept" @change="uploadFile"/>
      <span v-if="errorText" class="help-block">
        <p> {{ errorText }} </p>
      </span>
      <div v-if="photoSrc" class="photo-preview">
        <img :src="photoSrc" style="width:100%">
        <button type="button" class="btn btn-danger" @click="removePhoto">
          <i class="fa fa-trash"></i> Usuń
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    trueUpload: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: null
    },
    value: {
      type: String,
      default: null
    },
    photoDir: {
      type: String,
      default: '/upload/photos/'
    },
    photoTempDir: {
      type: String,
      default: '/upload/tmp/'
    },
    errors: {
      type: Object,
      default: () => {
      }
    },
    title: {
      type: String,
      default: ''
    },
    accept: {
      type: String,
      default: 'image/*'
    },
    maxSize: {
      type: Number,
      default: null
    }
  },
  data: function () {
    return {
      photo: null,
      uploaded: false,
      id: `form_${this.name}`,
      errorText: false,
    }
  },
  computed: {
    photoSrc() {
      if (!this.photo) {
        return false
      }

      return (this.trueUpload === true ? this.photoDir : this.photoTempDir) + this.photo
    },
    formattedMaxSize() {
      if (!this.maxSize) {
        return ''
      }

      if (this.maxSize >= 1000000) {
        return `${this.maxSize / 1000000} MB`
      }

      if (this.maxSize >= 1000) {
        return `${this.maxSize / 1000} KB`
      }

      return `${this.maxSize} B`
    }
  },
  watch: {
    errors: function (value) {
      if (value[this.name]) {
        this.errorText = Object.values(value[this.name]).join()
      } else {
        this.errorText = false
      }
    },
    value: function (value) {
      this.photo = value
    }
  },
  methods: {
    uploadFile: function (e) {
      var files = e.target.files || e.dataTransfer.files
      this.errorText = false

      if (!files.length) {
        this.errorText = Translator.trans('form.errors.invalid_file')
        return
      }

      if (this.maxSize && files[0].size > this.maxSize) {
        this.errorText = `${Translator.trans('form.errors.invalid_file_size')} ${this.formattedMaxSize}`
        return
      }

      var formData = new FormData()
      formData.append('file', files[0])

      var url = Routing.generate(this.trueUpload ? 'api_post_upload' : 'api_post_temp_upload')
      this.$emit('start-request')

      this.$http.post(url, formData)
        .then(response => {
          this.$emit('input', response.data)
          this.photo = response.data
          this.uploaded = true

          this.$emit('end-request')
        }, () => {
          this.$emit('end-request')
        })
    },
    removePhoto() {
      this.$emit('input', null)
      this.photo = null
    },
  }

}
</script>

<style scoped>
.photo-preview {
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-top: 5px;
}

.photo-preview button {
  position: absolute;
  right: 20px;
}
</style>